import React from "react";
import TabAddBlogCategory from "./page-components/blog-category/TabAddBlogCategory";
import TabViewBlogCategory from "./page-components/blog-category/TabViewBlogCategory";
import MasterPageTab from "./page-essential/MasterPageTab";

const BlogCategory = () => {
  return (
    <MasterPageTab
      addBtn="Add blog category"
      addTab={<TabAddBlogCategory />}
      viewBtn="View blog Category"
      viewTab={<TabViewBlogCategory />}
      pageHeading="Blog category"
      pageDescription="Add/modify/delete blog category"
      icon={null}
    />
  );
};

export default BlogCategory;
